import { BasicInfo, CareAdvisorProfile, Language, UserProfile } from '@brands/services/identity/types/UserProfile';
import { parsePhoneNumber } from 'libphonenumber-js';

import { CAMyProfileSubmit } from '../utils/types';

export function hasBasicInfoChanged(currentUser: UserProfile, newData: BasicInfo): boolean {
  const normalizeLanguages = (langs: Language[] | string[] = []) =>
    langs.map((lang: any) => (typeof lang === 'string' ? lang : lang.id?.toString())).sort();

  const currentLanguages = normalizeLanguages(currentUser?.basic_info?.languages || []);
  const newLanguages = normalizeLanguages(newData.languages || []);

  return (
    currentUser?.basic_info?.first_name !== newData.first_name ||
    currentUser?.basic_info?.middle_name !== newData.middle_name ||
    currentUser?.basic_info?.last_name !== newData.last_name ||
    currentUser?.basic_info?.gender !== newData.gender ||
    currentUser?.basic_info?.pronouns !== newData.pronouns ||
    currentUser?.basic_info?.gender_identity !== newData.gender_identity ||
    JSON.stringify(currentLanguages) !== JSON.stringify(newLanguages)
  );
}

export function hasContactInfoChanged(currentUser: UserProfile, newData: CAMyProfileSubmit): boolean {
  const normalizedPhone = newData.phone_number ? parsePhoneNumber(newData.phone_number, 'US')?.format('E.164') : null;

  const addressChanged =
    currentUser?.address?.address1 !== newData.address1 ||
    currentUser?.address?.address2 !== newData.address2 ||
    currentUser?.address?.city !== newData.city ||
    currentUser?.address?.state !== newData.state ||
    currentUser?.address?.zip_code !== newData.zip_code;

  const phoneChanged = currentUser?.phone_number !== normalizedPhone;

  return phoneChanged || addressChanged;
}

export function hasCareAdvisorProfileChanged(
  currentProfile: CareAdvisorProfile,
  updated: { biography: string },
): boolean {
  if (!currentProfile) return true;
  return currentProfile.biography !== updated.biography;
}
